import { googlePlayUrl } from '@repo/config';

export function buildGooglePlayHandoffUrl(handoffToken: string): string {
  const url = new URL(googlePlayUrl);
  const referrer = new URLSearchParams();
  referrer.set('english_iq_handoff', handoffToken);
  url.searchParams.set('referrer', referrer.toString());
  return url.toString();
}
